import { useEffect, RefObject } from "react"

export function useOutsideClick<T extends HTMLElement>(
    ref: RefObject<T>,
    onClickOutside: () => void
) {
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (
                ref.current !== null &&
                event.target !== null &&
                !ref.current.contains(event.target as Node)
            ) {
                onClickOutside()
            }
        }

        document.addEventListener("mousedown", handleClickOutside)

        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [ref, onClickOutside])
}
